import { FunctionalComponentOptions } from "vue/types";
import moment from "moment";
import { Nullable, PartialInvoicingDate } from "@/types";
import { formatEuro } from "@/util/money";

type Props = {
    value: Nullable<PartialInvoicingDate[]> | undefined;
};

export default (): FunctionalComponentOptions<Props> => ({
    functional: true,
    render(createElement, { props }) {
        const termijnen = Array.isArray(props.value) ? props.value : [];

        if (termijnen.length === 0) return createElement("span", "-");

        return createElement(
            "div",
            { class: "text-right" },
            termijnen.map((termijn, index) =>
                createElement(
                    "div",
                    { key: index },
                    `${termijn.invoiceDate ? moment(termijn.invoiceDate).format("DD-MM-YYYY") : "-"} · ${formatEuro(
                        termijn.invoiceValue
                    )}`
                )
            )
        );
    }
});
